const EMPTY_IMAGE_SRC = '/images/favicon/empty.jpg';

export default {
  computed: {
    empty_image() {
      return EMPTY_IMAGE_SRC
    }
  }
}
